import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import DataSequence from "application/components/CTLDataSequence";
import { callCenterConfigMenuMoreVert } from "globals/configuration/callCenterConfigMenuMoreVert";
import AgentContactUpdate from "application/modules/configuration/callCenterConfiguration/switchACD/association/Update";
import AgentRecording from "application/modules/configuration/callCenterConfiguration/switchACD/association/Recording";

const Attributes = {
  formSize: "md",
  columns: 3,
  enableAddButton: true,
  settingsMode: false,
  enableAddAgentButton: false,
  enableAcdDetails: true,
  selectUrl: "/queue/list/acdList",
  modes: callCenterConfigMenuMoreVert.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
    };
  }),
};

const operationURLS = {
  agentList: "/agent/listQueue",
  agentCreate: "/agent/create",
  delete: "agent/delete",
};
const getColumns = (onDelete, onEdit, onChange,) => {
  return [
    {
      Header: "Agent From",
      accessor: "from",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Agent To",
      accessor: "to",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Agent/User ID",
      accessor: "name",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Agent/User Name",
      accessor: "agentFullName",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Email ID",
      accessor: "emailId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "ID",
      accessor: "id",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Phone Number",
      accessor: "contactNo",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    // {
    //   Header: "Description",
    //   accessor: "description",
    //   displayInList: false,
    //   allowInForm: false,
    //   allowFilter: false,
    //   dataType: "string",
    //   Cell: ({ value }) => <DefaultCell value={value} />,
    // },
    {
      Header: "Position",
      accessor: "position",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ row, value }) => (
        <DataSequence row={row} value={value} onChange={onChange} />
      ),
    },
    {
      Header: "Action",
      accessor: "",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ row, value }) => (
        <div>
          <AgentContactUpdate
            row={row}
            value={value}
            callCenter={true}
            onChange={onChange}
          />
          <AgentRecording row={row} callCenter={true} onChange={onChange} />
        </div>
      ),
    },
    {
      Header: "Queue",
      accessor: "queue",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "",
      accessor: "idd",
      displayInList: false,
      allowInForm: false,
      Cell: ({ row, value }) => <DataSequence row={row} value={value} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
